"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageClient = void 0;
const misc_1 = require("../typeGuards/misc");
class LocalStorageClientClass {
    getListenKey(cachePrefix) {
        const keyFromStorage = localStorage.getItem(`${cachePrefix}-lk`);
        if (keyFromStorage === null)
            return null;
        try {
            const parsed = JSON.parse(keyFromStorage);
            if ((0, misc_1.isStorageListenKey)(parsed))
                return parsed;
        }
        catch (e) {
            return null;
        }
        return null;
    }
    setListenKey(cachePrefix, keyToSet) {
        localStorage.setItem(`${cachePrefix}-lk`, JSON.stringify(keyToSet));
    }
    removeListenKey(cachePrefix) {
        localStorage.removeItem(`${cachePrefix}-lk`);
    }
}
exports.LocalStorageClient = new LocalStorageClientClass();
